import { defineComponent, onMounted, onUnmounted } from 'vue';
import OrganisationLinking from '@/presentation/components/organisation-linking/organisation-linking.vue';
import LinkedOrganisationsCode from '@/presentation/pages/linked-organisations/linked-organisations.code';

export default defineComponent({
	components: {
		OrganisationLinking
	},
	setup: () => {
		const code = new LinkedOrganisationsCode();

		onMounted(code.mounted.bind(code));
		onUnmounted(code.unmounted.bind(code));

		return {
			isCampaignTypeCustomProducts: code.isCampaignTypeCustomProducts
		};
	}
});
